export enum ListingType {
    PRIMARY = "PRIMARY",
    DEPARTMENT = "DEPARTMENT"
}

export interface ListingAPI {
    id: string
    dealerId: string
    listingType: ListingType
    idInSource: string
    engineId: string
    listingTypeId: string
    statusSync:string

}

export interface ListingUI {
    id: string
    dealerId: string
    type: ListingType
    idInSource: string
    engineId: string
    deparmentId?: string
    statusSync:string
}

export interface SyncErrorsFields {
    fieldName: string
    errorMessage: string
}

export interface ListingSyncErrorsAPI{
    listingId: string
    generalError: string
    fieldsErrors: SyncErrorsFields[] 
}

export interface ListingSyncErrorsUI{
    listingId: string
    generalError: string
    fieldsErrors: SyncErrorsFields[] 
}

export interface DealerListingsWithErrorsAPI{
    listingId: string
    hasErrors: boolean
}

export interface DealerListingsWithErrorsUI{
    listingId: string
    hasErrors: boolean
}

export interface LMValidation {
    imagesValidation?: LMImageValidationSettings
    urlsValidation?: LMURLsValidation
    descriptionValidation?: LMDescriptionValidation
    aboutValidation?: LMDescriptionValidation
}

export interface LMDescriptionValidation {
    minCharacters?: number
    maxCharacters?: number
}

export interface LMImageValidationSettings {
    imagesRequirements?: LMImagesValidation[]
    information?: LMImagesInformationMessages[]
}

export interface LMImagesInformationMessages {
    category?: string
    message?: string
}

export interface LMURLsValidation {
    urlFormat?: boolean
    urlExists?: boolean
}

export interface LMImagesValidation {
    category?: string
    rangeDimension?: string
    rangeAspectRadio?: string
    rangeFileSize?: string
    lessThanMinDimensionsAction?: string
    upperThanMaxDimensionsAction?: string
    lessThanMinAspectRadioAction?: string
    upperThanMaxAspectRadioAction?: string
    lessThanMinFileSizeAction?: string
    upperThanMaxFileSizeAction?: string
}

export interface RangeDimensions {
    minDimensions?: Dimensions
    maxDimensions?: Dimensions
}

export interface Dimensions {
    width?: number
    height?: number
}

export interface RangeAspectRadio {
    minAspectRadio?: number
    maxAspectRadio?: number
}

export interface RangeFileSize {
    minFileSizeKB?: number
    maxFileSizeKB?: number
}

export interface ValidationAction {
    actionType?: string
}

export interface ListingDB {
    id: string
    entityType: string
    dealerId: string
    listingType: ListingType
    idInSource: string
    engineId: string
    listingTypeId: string
    accountId: string
    statusSync: string
    dateSync: Date
}

export interface ChangedListingInfoAPI {
    listing: ListingDB
    departmentName: string
    fieldsChanged: string[]
}

export interface ChangedInfoAPI {
    changedListingsInfo: ChangedListingInfoAPI[]
}

export interface ChangedListingInfoUI {
    listing: ListingUI
    departmentName: string
    fieldsChanged: string[]
}

export interface ChangedInfoUI {
    changedListingsInfo: ChangedListingInfoUI[]
}
